module.exports = __webpack_public_path__ + "img/Web-Al-Lusail-Tom-van-Oossanen-454.jpg";